import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

const KEY = "eden_ui_sound";
const TARGET = "a, button, [role='button'], summary";
let ctx = null;

function play(freq, dur, gain) {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    const o = ctx.createOscillator(), g = ctx.createGain(), t = ctx.currentTime;
    o.type = "sine"; o.frequency.setValueAtTime(freq, t); o.frequency.exponentialRampToValueAtTime(freq * 0.6, t + dur);
    g.gain.setValueAtTime(gain, t); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g).connect(ctx.destination); o.start(t); o.stop(t + dur);
  } catch { /* audio unavailable */ }
}

export function UiSound() {
  const [on, setOn] = useState(() => localStorage.getItem(KEY) === "1");

  useEffect(() => {
    localStorage.setItem(KEY, on ? "1" : "0");
    if (!on) return;
    let last = null;
    const onOver = (e) => {
      const el = e.target.closest?.(TARGET);
      if (el && el !== last) play(1400, 0.04, 0.025);
      last = el;
    };
    const onDown = (e) => { if (e.target.closest?.(TARGET)) play(600, 0.08, 0.05); };
    document.addEventListener("mouseover", onOver, { passive: true });
    document.addEventListener("mousedown", onDown, { passive: true });
    return () => { document.removeEventListener("mouseover", onOver); document.removeEventListener("mousedown", onDown); };
  }, [on]);

  const toggle = () => { const next = !on; setOn(next); if (next) play(900, 0.1, 0.05); };
  const Icon = on ? Volume2 : VolumeX;
  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={on}
      aria-label={on ? "Silenciar sons de interface" : "Ativar sons de interface"}
      title={on ? "Silenciar sons" : "Ativar sons"}
      className="fixed bottom-5 right-5 z-40 inline-flex h-10 w-10 items-center justify-center rounded-full border border-eden-border bg-eden-bg/80 text-eden-secondary backdrop-blur transition-colors duration-200 hover:border-eden-orange hover:text-eden-orange focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-eden-orange"
      data-testid="ui-sound-toggle"
    >
      <Icon size={18} aria-hidden="true" />
    </button>
  );
}
